// Il backend serializza gli enum come stringa (JsonStringEnumConverter),
// quindi "value" deve corrispondere al nome del membro C# di StatoPagamento.
export const STATI_PAGAMENTO = [
    { label: "Da pagare", value: "DaPagare" },
    { label: "Pagato", value: "Pagato" },
    { label: "Annullato", value: "Annullato" },
];

const COLORI_STATO = {
    DaPagare: "success",
    Pagato: "info",
    Annullato: "grey",
};

export function coloreStatoPagamento(stato) {
    return COLORI_STATO[stato] || "grey";
}

export function etichettaStatoPagamento(stato) {
    return (STATI_PAGAMENTO.find(s => s.value === stato) || {}).label || "";
}

// "Scaduto" calcolato client-side (Pagamento non ha, come ScadenzaMezzo, un
// campo calcolato server-side garantito dal contratto): DaPagare con
// DataScadenza nel passato.
export function isScaduto(item) {
    if (!item || item.stato !== "DaPagare" || !item.dataScadenza) return false;
    const oggi = new Date();
    oggi.setHours(0, 0, 0, 0);
    const scadenza = new Date(item.dataScadenza);
    scadenza.setHours(0, 0, 0, 0);
    return scadenza.getTime() < oggi.getTime();
}

export function coloreRiga(item) {
    if (isScaduto(item)) return "error";
    return coloreStatoPagamento(item.stato);
}

export function etichettaRiga(item) {
    if (isScaduto(item)) return "Scaduto";
    return etichettaStatoPagamento(item.stato);
}
